const lesson = {
    "LBL_TRIAL_LESSON_STAGE":"Запись на урок",
    "LBL_TECH_LESSON_STAGE":"Запись на тестирование",
    "LBL_TECH_STAGE":"Проведение тестирования",
    "LBL_TRIAL_STAGE":"Пробный урок",
    "LBL_TRIAL_LESSON_TITLE":"Бронирование пробного урока",
    "LBL_TRIAL_LESSON_DATES_SELECT":"Выберите дату, время проведения урока",
    "LBL_DATE_SELECTED_HELPER":"Доступные уроки на",
    "LBL_WROTE_PHONE":"Укажите контактный номер",
    "LBL_PHONE_HELPER":"Обратите внимание что неправильно указанный номер приведет к возможности потерять бесплатный пробный урок",
    "NO_LESSONS_WORKLOAD":"На выбранную дату нет уроков.<br/>Пожалуйста, попробуйте другой день"
};
export default lesson